import { render, staticRenderFns } from "./miniGoodsList.vue?vue&type=template&id=1e2ce896&scoped=true&"
import script from "./miniGoodsList.vue?vue&type=script&lang=js&"
export * from "./miniGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./miniGoodsList.vue?vue&type=style&index=0&id=1e2ce896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ce896",
  null
  
)

export default component.exports